<template>
    <div class="container-fluid">
        <ToastTemplet :bus="toast"></ToastTemplet>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Import Excel</h3>

                        <div class="card-tools d-flex align-items-center gap-2">
                            <!-- ✅ Download Sample Excel -->
                            <a
                                href="/storage/Sample_Excel_Format.xlsx"
                                download
                                class="btn btn-primary mx-3"
                            >
                                <i class="fa fa-download me-1"></i> Download
                                Sample Excel
                            </a>

                            <!-- Existing File Upload -->
                            <input
                                class="btn btn-success"
                                type="file"
                                ref="excelFileUpload"
                                @change="previewFiles"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.row -->

        <!-- Incorrect data -->
        <div v-if="HeaderDisplayInCorrectdata" class="row mt-5">
            <div class="col-md-12">
                <div class="card card-danger">
                    <div class="card-header">
                        <h3 class="card-title">InCorrect Data</h3>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                            <tr>
                                <th>NO</th>
                                <th>LOGIN ID</th>
                                <th>Bank NAME</th>
                                <th>PRODUCT</th>
                                <th>APPLICANT NAME</th>
                                <th>RESI ADDRESS</th>
                                <th>Office ADDRESS</th>
                                <th>Fi Bank Location</th>
                                <th>Office Name</th>
                                <th>Company Name</th>
                            </tr>
                            <tr
                                v-for="(employee_master,
                                i) in InCorrectExcelData"
                                :key="employee_master.BANK_ID"
                            >
                                <td>{{ i + 1 }}</td>
                                <td>{{ employee_master.Login_Id }}</td>
                                <td>{{ employee_master.Bank_Name }}</td>
                                <td>{{ employee_master.Product_Name }}</td>
                                <td>{{ employee_master.Applicant_Name }}</td>
                                <td>
                                    {{ employee_master.Residential_Address }}
                                </td>
                                <td>{{ employee_master.Office_Address }}</td>
                                <td>
                                    {{ employee_master.Fi_Bank_Location }}
                                </td>
                                <td>
                                    {{ employee_master.Office_Name }}
                                </td>
                                <td>
                                    {{ employee_master.Company_Name }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>
        </div>
        <!-- /.row -->
        <!-- Incorrect data END -->
        <!-- Correct Data -->
        <div v-if="HeaderDisplayCorrectdata" class="row mt-5">
            <div class="col-md-12">
                <div class="card card-success">
                    <div class="card-header">
                        <h3 class="card-title">Correct Data</h3>
                        <button
                            type="button"
                            @click="UploadExcel"
                            class="btn btn-primary float-right"
                        >
                            Upload
                        </button>
                    </div>
                    <div class="card-body table-responsive p-0">
                        <table class="table table-hover">
                            <tr>
                                <th>NO</th>
                                <th>LOGIN ID</th>
                                <th>Bank NAME</th>
                                <th>PRODUCT</th>
                                <th>APPLICANT NAME</th>
                                <th>RESI ADDRESS</th>
                                <th>Office ADDRESS</th>
                                <th>Fi Bank Location</th>
                                <th>Office Name</th>
                                <th>Company Name</th>
                            </tr>
                            <tr
                                v-for="(employee_master, i) in CorrectExcelData"
                                :key="employee_master.BANK_ID"
                            >
                                <td>{{ i + 1 }}</td>
                                <td>{{ employee_master.Login_Id }}</td>
                                <td>{{ employee_master.Bank_Name }}</td>
                                <td>{{ employee_master.Product_Name }}</td>
                                <td>{{ employee_master.Applicant_Name }}</td>
                                <td>
                                    {{ employee_master.Residential_Address }}
                                </td>
                                <td>{{ employee_master.Office_Address }}</td>
                                <td>
                                    {{ employee_master.Fi_Bank_Location }}
                                </td>
                                <td>
                                    {{ employee_master.Office_Name }}
                                </td>
                                <td>
                                    {{ employee_master.Company_Name }}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!-- /.card-body -->
                </div>
            </div>
        </div>
        <!-- /.row -->
        <!-- Correct data END -->
        <!-- Form -->
        <div
            v-if="
                HeaderDisplayCorrectdata == false ||
                    HeaderDisplayInCorrectdata == false
            "
            class="card card-primary"
        >
            <div class="card-header">
                <h3>Add Applicant</h3>
            </div>
            <!-- /.card-header -->
            <!-- form start -->
            <form @submit.prevent="CreateClientMaster()">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Login Id</label>
                                <input
                                    v-model="form.Login_Id"
                                    type="text"
                                    name="Login_Id"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Login_Id'
                                        )
                                    }"
                                />
                                <has-error
                                    :form="form"
                                    field="Login_Id"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Bank Name</label>
                                <multiselect
                                    v-model="form.BANK_ID_REF"
                                    :options="bank_master1"
                                    :allow-empty="false"
                                    open-direction="bottom"
                                    deselect-label="Can't remove this value"
                                    label="Bank_Name"
                                    track-by="BANK_ID"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'BANK_ID_REF'
                                        )
                                    }"
                                    @input="afterBankSelect"
                                    aria-required="true"
                                >
                                </multiselect>
                                <has-error
                                    :form="form"
                                    field="Bank_Name"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Bank Branch</label>
                                <multiselect
                                    v-model="form.BANK_BRANCH_ID"
                                    :options="Bank_Branch_Master_For_Bank"
                                    :allow-empty="false"
                                    open-direction="bottom"
                                    deselect-label="Can't remove this value"
                                    label="Bank_Branch_Name"
                                    track-by="BANK_BRANCH_ID"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'PRODUCT_ID_REF'
                                        )
                                    }"
                                    aria-required="true"
                                >
                                </multiselect>
                                <has-error
                                    :form="form"
                                    field="Bank_Branch_Name"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Product Name</label>
                                <multiselect
                                    v-model="form.PRODUCT_ID_REF"
                                    :options="Product_Master_For_Bank"
                                    :allow-empty="false"
                                    open-direction="bottom"
                                    deselect-label="Can't remove this value"
                                    label="Product_Name"
                                    track-by="PRODUCT_ID"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'PRODUCT_ID_REF'
                                        )
                                    }"
                                    aria-required="true"
                                >
                                </multiselect>
                                <has-error
                                    :form="form"
                                    field="Product_Name"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Applicant Name</label>
                                <input
                                    v-model="form.Applicant_Name"
                                    type="text"
                                    name="Applicant_Name"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Applicant_Name'
                                        )
                                    }"
                                />
                                <has-error
                                    :form="form"
                                    field="Applicant_Name"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Executive Location</label>
                                <multiselect
                                    v-model="form.Location"
                                    :options="Location_Master"
                                    :allow-empty="false"
                                    open-direction="bottom"
                                    deselect-label="Can't remove this value"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Location'
                                        )
                                    }"
                                    aria-required="true"
                                >
                                </multiselect>
                                <has-error
                                    :form="form"
                                    field="Location"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>FI Bank Location</label>
                                <multiselect
                                    v-model="form.Fi_Bank_Location"
                                    :options="FI_Bank_Location_Master"
                                    :allow-empty="false"
                                    open-direction="bottom"
                                    deselect-label="Can't remove this value"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Fi_Bank_Location'
                                        )
                                    }"
                                    aria-required="true"
                                >
                                </multiselect>
                                <has-error
                                    :form="form"
                                    field="Fi_Bank_Location"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Residential Address</label>
                                <textarea
                                    v-model="form.Residential_Address"
                                    type="text"
                                    name="Residential_Address"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Residential_Address'
                                        )
                                    }"
                                ></textarea>
                                <has-error
                                    :form="form"
                                    field="Residential_Address"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Office Name</label>
                                <input
                                    v-model="form.Office_Name"
                                    type="text"
                                    name="Office_Name"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Office_Name'
                                        )
                                    }"
                                />
                                <has-error
                                    :form="form"
                                    field="Office_Name"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Office Address</label>
                                <textarea
                                    v-model="form.Office_Address"
                                    type="text"
                                    name="Office_Address"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Office_Address'
                                        )
                                    }"
                                ></textarea>
                                <has-error
                                    :form="form"
                                    field="Office_Address"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label>Loan Amount</label>
                                <input
                                    v-model="form.Loan_Amount"
                                    type="text"
                                    name="Loan_Amount"
                                    class="form-control"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Loan_Amount'
                                        )
                                    }"
                                />
                                <has-error
                                    :form="form"
                                    field="Loan_Amount"
                                ></has-error>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label>Company Name</label>
                                <multiselect
                                    v-model="form.Company_Name"
                                    :options="Company_Name_Master"
                                    :allow-empty="false"
                                    open-direction="bottom"
                                    deselect-label="Can't remove this value"
                                    :class="{
                                        'is-invalid': form.errors.has(
                                            'Company_Name'
                                        )
                                    }"
                                    aria-required="true"
                                >
                                </multiselect>
                                <has-error
                                    :form="form"
                                    field="Company_Name"
                                ></has-error>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary">
                            Save Applicant
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <!-- End Form -->
    </div>
</template>
<script>
import ToastTemplet from "../widget/toast";
import xlsx from "xlsx";
export default {
    components: { Multiselect, ToastTemplet },
    data() {
        return {
            Product_Master: [],
            bank_master: [],
            bank_master1: [],
            LoginId_master: [],
            Product_Master_For_Bank: [],
            HeaderDisplayCorrectdata: false,
            HeaderDisplayInCorrectdata: false,
            toast: new Vue(),
            metaDataFile: null,
            AllExcelData: {},
            CorrectExcelData: [],
            InCorrectExcelData: [],
            Remove_duplicate_Value: [],
            Bank_Branch_Master_For_Bank: [],
            Location_Master: ["local", "out", "osg"],
            Company_Name_Master: [
                "SARVOTTAM CONSULTANT",
                "SARVOTTAM VERIFICATION SERVICES PRIVATE LIMITED"
            ],
            FI_Bank_Location_Master: ["local", "out", "osg"],
            form: new Form({
                CLIENT_ID: "",
                Login_Id: "",
                BANK_ID_REF: "",
                PRODUCT_ID_REF: "",
                Product_Name: "",
                Applicant_Name: "",
                Residential_Address: "",
                Office_Address: "",
                Loan_Amount: "",
                Location: "",
                BANK_BRANCH_ID: "",
                Fi_Bank_Location: "",
                Company_Name: "",
                Office_Name: ""
            })
        };
    },
    mounted() {
        this.loadAllProduct();
        this.loadLoginId();
        this.loadBank();
        this.loadBankWithProduct();
    },
    methods: {
        UploadExcel() {
            if (this.CorrectExcelData.length) {
                this.toast.$emit("LoadingOn");

                axios
                    .post("/uploadClientExcel", this.CorrectExcelData)
                    .then(() => {
                        (this.HeaderDisplayCorrectdata = false),
                            (this.HeaderDisplayInCorrectdata = false),
                            (this.$refs.excelFileUpload.value = null);
                        this.CorrectExcelData = [];
                        this.InCorrectExcelData = [];
                        this.toast.$emit(
                            "LoadingOffSuccess",
                            "Excel Upload successfully"
                        );
                    })
                    .catch(() => {
                        this.toast.$emit(
                            "LoadingOffError",
                            "your request could not be processed."
                        );
                    });
            } else {
                this.toast.$emit("ToastWarning", "Fail..!! Please Retry");
            }
        },
        CreateClientMaster() {
            this.toast.$emit("LoadingOn");
            this.form.Loan_Amount = this.form.Loan_Amount.toString().replace(
                /[^0-9]/g,
                ""
            );
            this.form
                .post("client")
                .then(() => {
                    $("#Client_Model").modal("hide");
                    // this.loadAndSearchClientForAssign();
                    this.form.reset();
                    Fire.$emit("AfterChangeClient");
                    this.toast.$emit(
                        "LoadingOffSuccess",
                        "Client Create successfully"
                    );
                })
                .catch(error => {
                    if (error.response && error.response.status === 422) {
                        this.errors = error.response.data.errors || {};
                        const first =
                            Object.values(this.errors)[0]?.[0] ||
                            "Please fix the errors.";
                        this.toast.$emit("LoadingOffError", first);
                    } else {
                        this.toast.$emit(
                            "LoadingOffError",
                            "Your Request failed."
                        );
                    }
                });
        },
        loadAllProduct() {
            axios
                .get("/loadAllProduct")
                .then(({ data }) => {
                    this.Product_Master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadBankWithProduct() {
            axios
                .get("/loadBankWithProduct")
                .then(({ data }) => {
                    this.bank_master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        afterselect_bank() {
            axios
                .get("/afterselect_bank/" + this.form.BANK_ID_REF.BANK_ID)
                .then(({ data }) => {
                    this.Bank_Branch_Master_For_Bank = data;
                }, (this.form.BANK_BRANCH_ID = ""))
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        afterBankSelect() {
            this.afterselect_bank();
            axios
                .get("/loadProductBankWise/" + this.form.BANK_ID_REF.BANK_ID)
                .then(({ data }) => {
                    this.Product_Master_For_Bank = data;
                }, (this.form.PRODUCT_ID_REF = ""))
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadBank() {
            axios
                .get("/loadBank")
                .then(({ data }) => {
                    this.bank_master1 = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        loadLoginId() {
            axios
                .get("/loadLoginId")
                .then(({ data }) => {
                    this.LoginId_master = data;
                })
                .catch(() => {
                    this.toast.$emit(
                        "ProgressBarFailerror",
                        "Cannot Find Any data"
                    );
                });
        },
        previewFiles(e) {
            const files = e.target.files;
            console.log(files);
            if (!files.length) {
                return;
            } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
                this.$refs.excelFileUpload.value = null;
                this.toast.$emit(
                    "ToastWarning",
                    "The upload format is incorrect. Please upload xls or xlsx format"
                );
            }
            const fileReader = new FileReader();
            fileReader.onload = ev => {
                try {
                    const data = ev.target.result;
                    const XLSX = xlsx;
                    const workbook = XLSX.read(data, {
                        type: "binary"
                    });
                    const wsname = workbook.SheetNames[0]; // Take the first sheet，wb.SheetNames[0] :Take the name of the first sheet in the sheets
                    const ws = XLSX.utils.sheet_to_json(
                        workbook.Sheets[wsname]
                    ); // Generate JSON table content，wb.Sheets[Sheet名]    Get the data of the first sheet
                    const excellist = []; // Clear received data
                    // Edit data
                    for (var i = 0; i < ws.length; i++) {
                        excellist.push(ws[i]);
                    }
                    this.AllExcelData = excellist;
                    this.verifyAllExcelData(this.AllExcelData);

                    // console.log("Read results", excellist); // At this point, you get an array containing objects that need to be processed
                } catch (e) {
                    this.toast.$emit("ToastWarning", "Read failure!");
                }
            };
            fileReader.readAsBinaryString(files[0]);
        },
        verifyAllExcelData(DATA) {
            if (DATA.length) {
                for (var i = 0; i < DATA.length; i++) {
                    this.bank_master.filter(item => {
                        if (
                            item.Product_Name == DATA[i].Product_Name &&
                            item.Bank_Name == DATA[i].Bank_Name &&
                            item.Bank_Branch_Code == DATA[i].Bank_Code
                        ) {
                            DATA[i]["PRODUCT_ID_REF"] = item.PRODUCT_ID;
                            DATA[i]["BANK_BRANCH_ID_REF"] = item.Bank_Branch_ID;
                        }
                    });
                    var flag = 0;
                    if (DATA[i]["Login_Id"] != undefined) {
                        if (DATA[i]["Login_Id"].toString().length > 20) {
                            (DATA[i]["Login_Id"] = "To Loong"), (flag = 1);
                        }
                    } else {
                        flag = 1;
                    }
                    if (DATA[i]["PRODUCT_ID_REF"] != undefined) {
                        DATA[i]["Product_Name"] = DATA[i].Product_Name;
                    } else {
                        (flag = 1),
                            (DATA[i]["Product_Name"] = "Not Found"),
                            (DATA[i]["Bank_Name"] = "Not Found");
                    }
                    if (DATA[i]["Applicant_Name"] != undefined) {
                        if (DATA[i]["Applicant_Name"].toString().length > 300) {
                            (DATA[i]["Applicant_Name"] = "To Loong"),
                                (flag = 1);
                        }
                    } else {
                        flag = 1;
                    }
                    if (DATA[i]["Loan_Amount"] != undefined) {
                        DATA[i]["Loan_Amount"] = DATA[
                            i
                        ].Loan_Amount.toString().replace(/[^0-9]/g, "");
                        if (DATA[i]["Loan_Amount"].toString().length > 20) {
                            (DATA[i]["Loan_Amount"] = "To Loong"), (flag = 1);
                        }
                    } else {
                        flag = 1;
                    }
                    if (
                        (DATA[i]["Residential_Address"] ||
                        DATA[i]["Office_Address"])
                    ) {
                        if (
                            DATA[i]["Residential_Address"]
                        ) {
                            if (
                                DATA[i]["Residential_Address"].toString()
                                    .length > 200
                            ) {
                                (DATA[i]["Residential_Address"] = "To Loong"),
                                    (flag = 1);
                            }
                        }
                        if (
                            DATA[i]["Office_Address"]
                        ) {
                            if (
                                DATA[i]["Office_Address"].toString().length >
                                200
                            ) {
                                (DATA[i]["Office_Address"] = "To Loong"),
                                    (flag = 1);
                            }
                        }
                    } else {
                        flag = 1;
                    }

                    if (
                        DATA[i]["Fi_Bank_Location"].toString().trim() !=
                            "local" &&
                        DATA[i]["Fi_Bank_Location"].toString().trim() !=
                            "out" &&
                        DATA[i]["Fi_Bank_Location"].toString().trim() != "osg"
                    ) {
                        DATA[i]["Fi_Bank_Location"] = "Invalid Bank Location";
                        flag = 1;
                    }

                    if (
                        DATA[i]["Office_Name"] === undefined ||
                        DATA[i]["Office_Name"].toString().trim() === ""
                    ) {
                        DATA[i]["Office_Name"] = "Missing";
                        flag = 1;
                    } else if (DATA[i]["Office_Name"].toString().length > 200) {
                        DATA[i]["Office_Name"] = "Too Long";
                        flag = 1;
                    }

                    if (
                        DATA[i]["Company_Name"] !==
                            "SARVOTTAM VERIFICATION SERVICES PRIVATE LIMITED" &&
                        DATA[i]["Company_Name"] !== "SARVOTTAM CONSULTANT"
                    ) {
                        DATA[i]["Company_Name"] = "Invalid Company Name";
                        flag = 1;
                    }

                    if (flag == 1) {
                        this.HeaderDisplayInCorrectdata = true;
                        this.InCorrectExcelData.push(DATA[i]);
                    } else {
                        this.HeaderDisplayCorrectdata = true;
                        this.CorrectExcelData.push(DATA[i]);
                    }
                }
            }
        },
        uniqByKeey(data, key) {
            return [...new Map(data.map(x => [key(x), x])).values()];
        }
    }
};
</script>
